import { useSmokeballApp } from "@smart/itops-smokeball-app-dom";
import {
  MatterSubmission,
  useLoadMatterType,
} from "@smart/manage-gql-client-dom";
import { useRoleContacts } from "@smart/manage-hooks-dom";

import { SubmissionActions } from "./actions";

export type SubmissionActionsProps = { onViewClose: () => void } & Record<
  "cancelling" | "deleting" | "reminding" | "editing",
  { selected?: MatterSubmission; onClose: () => void }
>;

export const SubmissionActionsWithMatterContext = ({
  onViewClose,
  cancelling,
  deleting,
  reminding,
}: SubmissionActionsProps) => {
  const { matters } = useSmokeballApp();
  const roleContacts = useRoleContacts();
  const loadMatterType = useLoadMatterType(
    {
      matterTypeId: matters?.current?.matterTypeId || "",
    },
    { skip: !matters?.current?.matterTypeId },
  );

  const matterType =
    loadMatterType.loading || !matters?.current
      ? undefined
      : loadMatterType.result || { name: "", id: "" };

  return (
    <SubmissionActions
      matter={matters?.current}
      matterType={matterType}
      roleContacts={roleContacts}
      onViewClose={onViewClose}
      cancelling={cancelling}
      deleting={deleting}
      reminding={reminding}
    />
  );
};
